import { ReactSetStateFunction } from "@utils/utility-types";
import { Text } from "@flat-ui";

interface Props {
  /** Setter for shouldDisableContinueButton */
  setShouldDisableContinueButton: ReactSetStateFunction<boolean>;
}

/** Content for step 1 of delete member */
export function DeleteMemberStep1({
  setShouldDisableContinueButton,
}: Props): React.JSX.Element {
  setShouldDisableContinueButton(false);

  return (
    <Text variant="bodyM">
      This action is permanent and takes effect immediately. Before deleting,
      ensure:
      <ul>
        <li>
          Deletion requests must originate from Legal/Compliance, not directly
          from the member. If this is not the case, await approval from{" "}
          <b>dpo@faro.com</b>.
        </li>
        <li>
          If the member requested deletion directly, forward their request to{" "}
          <b>dpo@faro.com</b> for review and close this dialog.
        </li>
        <li>
          All their data will be permanently removed from the FARO ecosystem.
        </li>
        <li>No deletion notification will be sent to the member.</li>
        <li>
          A new account using the same email can be created later if needed.
        </li>
      </ul>
    </Text>
  );
}
